<header role="banner" class="form-input__header">
  <p *ngIf="question.title" class="form-input__header__title" [innerHTML]="title"></p>
  <p *ngIf="question.subtitle" class="form-input__header__subtitle" [innerHTML]="subtitle"></p>
</header>

<mat-form-field
  *ngIf="(options?.length || 0) > 0"
  class="form-input__field form-input__field--text dropdown"
  floatLabel="never"
  [attr.dropdownOpen]="!!answerSelect?.panelOpen"
  [attr.dropdownSelected]="!!answerSelect?.value"
  appearance="legacy"
>
  <mat-label>{{ label || 'Votre réponse' }}</mat-label>
  <mat-select [formControl]="control" panelClass="dropdown-panel" #answerSelect="matSelect" [id]="elm_id">
    <mat-option *ngFor="let option of options; trackBy: trackByOption" [value]="option.value">{{
      option.label
    }}</mat-option>
  </mat-select>
  <mat-icon
    *ngIf="!answerSelect?.value"
    matSuffix
    svgIcon="arrow_next"
    aria-label="Icône du sélection de la réponse"
  ></mat-icon>
  <mat-icon
    *ngIf="!!answerSelect?.value"
    matSuffix
    svgIcon="cross"
    aria-label="Icône de suppression de sélection de la réponse"
    (click)="clearValue($event)"
  ></mat-icon>
  <mat-error *ngIf="control?.errors?.required">
    {{ errorMsg || 'Veuillez sélectionner une valeur' }}
  </mat-error>
</mat-form-field>

<footer class="form-input__actions">
  <button
    class="btn"
    type="button"
    (click)="next(control)"
    [attr.aria-label]="'Valider la question: ' + question.ariaLabel"
  >
    Valider
  </button>
  <button
    *ngIf="!required"
    class="btn-clean"
    type="button"
    (click)="skipQuestion.emit(control)"
    [attr.aria-label]="'Passer la question: ' + question.ariaLabel"
  >
    Passer
  </button>
</footer>
